module.exports = __webpack_public_path__ + "static/carlsbad-6-d2e67b4028c2f7b0de1baf19d91d11af.png";